// @ts-expect-error TS(2305): Module '"react/jsx-runtime"' has no exported membe... Remove this comment to see the full error message
import { jsx as _jsx } from "react/jsx-runtime"
import { useState, useEffect } from "react"
import { MultiSelect } from "primereact/multiselect"

const TableMultiSelect = ({
  options,
  itemTemplate,
  onChange
}: any) => {
  const [value, setValue] = useState()
  useEffect(() => {
    if (options) {
      const preselectedOptions = options.reduce((acummulator: any, option: any) => {
        if (!option.unchecked) {
          acummulator.push(option.value)
        }
        return acummulator
      }, [])
      setValue(preselectedOptions)
    }
  }, [options])
  return _jsx(
    MultiSelect,
    {
      style: { width: "100%" },
      value,
      onChange: (e: any) => {
        const values = e.value
        setValue(values)
        onChange(values)
      },
      itemTemplate,
      options,
      className: "p-column-filter",
    },
    void 0
  );
}
export default TableMultiSelect
